import {
  createRecProductVideoComponents,
  RecProduct,
  RecProductProps,
} from '@pro-page-components/rec-product';
import { useChildrenVisibilityEditor } from '@pro-page-components/utils/useChildrenVisibility';
import * as React from 'react';
import { ComponentForEditor } from 'react-page-editor/state';

import config from './config.json';
import defaultProps from './defaultProps.json';

const { Video, VideoEditor } = createRecProductVideoComponents({
  name: 'REC Alpha Pure Series Video',
  id: 'REC_ALPHA_PURE_VIDEO',
  path: '.....',
  parent: config.id,
});

export const RecAlphaPureSeries: ComponentForEditor<RecProductProps> = (
  props: RecProductProps,
) => <RecProduct VideoComponent={Video} {...props} />;

export const RecAlphaPureSeriesEditor: ComponentForEditor<RecProductProps> = (
  props: RecProductProps,
) => {
  // eslint-disable-next-line no-underscore-dangle,react/destructuring-assignment
  const visible = useChildrenVisibilityEditor(props.__config);
  if (!visible) return null;
  return (
    <RecAlphaPureSeries
      scale={0.9}
      skipVisibilityCheck
      VideoComponent={VideoEditor}
      {...props}
    />
  );
};

RecAlphaPureSeries.children = [Video];
RecAlphaPureSeries.defaultProps = defaultProps as RecProductProps;
RecAlphaPureSeries.config = config;
RecAlphaPureSeriesEditor.defaultProps = defaultProps as RecProductProps;
RecAlphaPureSeriesEditor.config = config;
RecAlphaPureSeriesEditor.children = [VideoEditor];
